import React from "react";

import { useGetBenAdminRenewalQuery } from "BenAdminRenewal/redux";
import EmployerBreadcrumbs from "EmployerDashboard/Components/Breadcrumbs";
import { Link, RouteComponentProps } from "react-router-dom";

import Chrome from "../components/Chrome";
import Layout from "../components/Layout";
import { CardSection } from "Cobalt/Card";
import { Table, HeaderTR, TH, TR, TD } from "Cobalt/TableV2";
import DashboardHeader from "Common/DashboardHeader";
import Icon from "Common/Icon";
import BodyText from "Theme/BodyText";
import { LinkButton } from "Theme/Button";

const StatusPage: React.FC<RouteComponentProps<{}>> = () => {
  const { isLoading: isLoadingBenAdminRenewal, data: benAdminRenewal } = useGetBenAdminRenewalQuery(null);
  const { employees = [] } = benAdminRenewal;
  const eligibleEmployees = employees.filter(({ isEligible }) => isEligible);

  const title = "Renewal Status";
  const crumbs = [
    { title: "Renewal", link: "/benefits-administration/renewal" },
    { title: "Status", link: "" },
  ];

  return (
    <Chrome title="SimplyInsured - Broker Dashboard">
      <Layout>
        <EmployerBreadcrumbs crumbs={crumbs} px={0} />
        <DashboardHeader title={title} subtitle="Follow the current status of your renewal" px={0} />
        {isLoadingBenAdminRenewal ? (
          <BodyText>Loading...</BodyText>
        ) : (
          <>
            <CardSection px={0}>
              <Table>
                <thead>
                  <HeaderTR>
                    <TH>Employee</TH>
                    <TH>Status</TH>
                    <TH>&nbsp;</TH>
                    {/* <TH align="left">Edit</TH> */}
                  </HeaderTR>
                </thead>
                <tbody>
                  {eligibleEmployees.map(({ name, renewalPolicyStatus, renewalApplicationRelativePath }, index) => (
                    <TR highlightFirstCell={false} key={index} withBorder={index !== eligibleEmployees.length - 1}>
                      <TD>{name}</TD>
                      <TD>{renewalPolicyStatus}</TD>
                      <TD align="left">
                        <Link to={renewalApplicationRelativePath}>
                          <Icon icon="pencil-alt" mr={3} />
                          Application
                        </Link>
                      </TD>
                    </TR>
                  ))}
                </tbody>
              </Table>
            </CardSection>
            <CardSection className="flex justify-between items-center" px={0}>
              <LinkButton component={Link} size="medium" to="/benefits-administration/renewal/employee-contributions" color="link" pl={0}>
                <Icon icon="chevron-left" pr={3} />
                Back
              </LinkButton>
              <LinkButton component={Link} size="medium" ml="auto" to="/employer-dashboard">
                Back to Dashboard
              </LinkButton>
            </CardSection>
          </>
        )}
      </Layout>
    </Chrome>
  );
};

export default StatusPage;
